import React, { Component } from 'react';
import { connect } from 'react-redux';
import Slider from 'rc-slider';

import { saveConfig, updateEfficiencyRange } from '../../FilterActions';

const Range = Slider.Range;

class EfficiencyRange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      range: [0, 100],
    };
  }

  componentDidMount() {
    this.setState({ range: this.props.range });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.range != this.props.range) {
      this.setState({ range: this.props.range });
    }
  }

  handleChange = (e) => {
    this.setState({ range: e });
  };

  handleAfterChange = (e) => {
    this.props.updateValue(e);
    this.props.saveConfig();
  };

  render() {
    const [low, high] = this.state.range || [0, 100];
    return (
      <div className="slider-control">
        <div className="slider-values slider-values--range">
          <span className="slider-value">{`${low}%`}</span>
          <span className="slider-value">{`${high}%`}</span>
        </div>
        <div className="slider-track">
          <Range
            min={0}
            max={100}
            defaultValue={[0, 100]}
            pushable={20}
            allowCross={true}
            value={this.state.range}
            onChange={this.handleChange}
            onAfterChange={this.handleAfterChange}
          />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    saveConfig: () => dispatch(saveConfig()),
    updateValue: (range) => dispatch(updateEfficiencyRange(range)),
  };
};

const mapStateToProps = (state) => {
  let chart = state.filters.chart;
  return {
    range: state.filters[chart].effRange,
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(EfficiencyRange);
export { connected as EfficiencyRange };
